import React from 'react';
import { ServiceType } from '../serviceType/ServiceType';
import { Stack } from '../../../../atoms/stack/Stack';

export const ChooseService = ({ types, selectedTypes, onTypeSelect }) => (
  <Stack className="flex-1 justify-between overflow-y-auto py-5">
    <div className="flex flex-col md:flex-row gap-5 flex-1">
      {types.map((type) => {
        const selected = type.id === selectedTypes[0];
        // selectedTypes.find((el) => el === index + 1) !== undefined;

        return (
          <ServiceType
            key={type.id}
            type={type}
            selected={selected}
            onTypeSelect={onTypeSelect}
          />
        );
      })}
    </div>
  </Stack>
);
